import { STATES } from "../constants/states"
import { i18n } from "@lingui/core"

export const getLocaleStates = () => {
  const country = i18n.locale.split("-")[1]
  const localeStates = STATES[country as keyof typeof STATES]
  const statesOptions = localeStates.map((state, i) => ({
    id: state + i,
    name: state,
    value: state,
  }))

  return statesOptions
}
